export const SHARED_EVENTS = {
  initialConfig: "initial-config",
};
